var swiper = new Swiper('.depositions-swiper', {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: false,
    allowTouchMove: true,

    pagination: {
        el: '.swiper-pagination',
        clickable: true,
        dynamicBullets: true,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    breakpoints: {
        // when window width is >= 600px
        700: {
            slidesPerView: 2,
            spaceBetween: 30,
            centeredSlides: false,
            freeMode: false,
            allowTouchMove: false,
            noSwiping: true,
            noSwipingClass: 'swiper-slide',
        },

        1000: {
            slidesPerView: 3,
            spaceBetween: 30,
            noSwiping: true,
            noSwipingClass: 'swiper-slide',
        },
    },
});
